import { getTradeFees } from "../api/apimethods";
import { TradeFees } from "../typings/models/TradeFees";

let tradeFees: TradeFees[] = [];

const fetchTradeFeesMaster = async () => {
  try {
    const response = await getTradeFees();
    tradeFees = response.data;
    return tradeFees; // Resolve the holidays array
  } catch (error) {
    console.error("Error fetching trade fees:", error);
    return []; // Return an empty array if there's an error
  }
};

export default fetchTradeFeesMaster;